export default "__VITE_ASSET__DyYtKKVp__"